var exports = {
  "a": "ExpandSection__YL-jcm",
  "p": "AnchoredReviewBody__9K8NYU",
};

module.exports = exports;
